module.exports = "/images/flag-zh-tw.svg?ba4eaa23e67ab0a128cbfcafeedd1545";